import { atom } from "recoil";

export const selectedTransfer = atom({
  key: "selectedTransfer",
  default: 0,
});
